import { fetchAuthSession } from 'aws-amplify/auth'

const getBaseUrl = () => process.env.REACT_APP_API_URL

async function authHeaders() {
  const { tokens } = await fetchAuthSession()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokens.idToken.toString()}`,
  }
}

export const api = {
  async getSnp500() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500`, { headers })
    if (!res.ok) throw new Error('Failed to fetch S&P 500 data')
    return res.json()
  },

  async triggerUpdate() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500/update`, {
      method: 'POST',
      headers,
    })
    if (!res.ok) throw new Error('Failed to trigger S&P 500 update')
    return res.json()
  },

  async getJobStatus(jobId) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500/update/${jobId}`, { headers })
    if (!res.ok) throw new Error('Failed to fetch job status')
    return res.json()
  },

  async submitFixes(fixes) {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500/fixes`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ fixes }),
    })
    if (!res.ok) throw new Error('Failed to submit symbol fixes')
    return res.json()
  },

  async getFixes() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500/fixes`, { headers })
    if (!res.ok) throw new Error('Failed to fetch fixes')
    return res.json()
  },

  async updateFix(original, replacement) {
    const headers = await authHeaders()
    const res = await fetch(
      `${getBaseUrl()}/snp500/fixes/${encodeURIComponent(original)}`,
      { method: 'PUT', headers, body: JSON.stringify({ replacement }) }
    )
    if (!res.ok) throw new Error('Failed to update fix')
    return res.json()
  },

  async deleteFix(original) {
    const headers = await authHeaders()
    const res = await fetch(
      `${getBaseUrl()}/snp500/fixes/${encodeURIComponent(original)}`,
      { method: 'DELETE', headers }
    )
    if (!res.ok) throw new Error('Failed to delete fix')
  },

  async getNoDataSymbols() {
    const headers = await authHeaders()
    const res = await fetch(`${getBaseUrl()}/snp500/no-data-symbols`, { headers })
    if (!res.ok) throw new Error('Failed to fetch no-data symbols')
    return res.json()
  },
}
